
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"13.343 9.634 65 20","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.25 12.003L21.75 12.003","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","transform":"matrix(3.333333, 0, 0, 3.333333, 5.842782, -10.37635)"}}),_c('path',{attrs:{"d":"M2.25 6.003L21.75 6.003","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","transform":"matrix(3.333333, 0, 0, 3.333333, 5.842782, -10.37635)"}})])
          )
        }
      }
    